import { Button } from "@material-ui/core";
import moment from "moment";
import React from "react";
import SignaturePad from "react-signature-canvas";
import LabelWithSwitch from "../switchWithLabel/switchWithLabel";
import TextFieldWithToolTip from "../TextFieldWithToolTip/TextFieldWithToolTip";
// eslint-disable-next-line no-unused-vars
import styles from "./styles.less";

export default class CanvasSignature extends React.Component {
 constructor(props){
  super(props)
 this.state = {
    selectedValueForSignKeyboard: true,
    textSignature: this.props.requestedFor,
    signingTimeFrame: moment().format("MM/DD/YYYY hh:mm:ss"),
    isSigned: false,
  };
}
  componentDidMount = () => {};
  sigPad = {};

  /** converter */
  convertToCanvas = () => {
    this.props.uploadFileToDb(
      this.sigPad.getTrimmedCanvas().toDataURL("image/png")
    );
  };

  /** set signature value to default */
  setToInitial = () => {
    this.setState({ textSignature: this.props.requestedFor });
  };

  /** take input from keyboard for signature */
  getSignatureFromKeyboard = () => {
    const tCtx = document.getElementById("textCanvas").getContext("2d"); //Hidden canvas
    tCtx.canvas.width = tCtx.measureText(this.state.textSignature).width * 2.3;    
    tCtx.font = tCtx.canvas.width > 100 ? "italic 14px Lucida Handwriting" :"italic 20px Lucida Handwriting";  
    tCtx.fillText(this.state.textSignature, 0, 30);
    return tCtx.canvas.toDataURL("image/png");
  };
  
  /** Get keybaord signature */
  getKeyboardSignature = () => {
    this.props.uploadFileToDb(this.getSignatureFromKeyboard());
  };

  /** Clear signpad */
  clear = () => {
    this.sigPad.clear();
  };

  /** trip and set value */
  trim = () => {
    this.props.isPOI ? this.submitSignatureCanvas() : this.convertToCanvas();
  };

  /** Submit signature */
  submitSignature = () => {
    this.props.saveSignature(this.getSignatureFromKeyboard());
  };

  /** Call on state change */
  changeState = (key, value) => {  
    this.setState({
      [key]: value,
    },()=>{this.forceUpdate()});
  };

  /** Submit canvas signature */
  submitSignatureCanvas = () => {
    this.props.saveSignature(
      this.sigPad.getTrimmedCanvas().toDataURL("image/png")
    );
  };

  render() {
    const { selectedValueForSignKeyboard, isSigned } = this.state;
    return (
      <>
        <div className={"col-xs-12"}>
          <div className={"col-xs-12"}>
            <LabelWithSwitch
              changeClassforLabel
              key={"Sign"}
              labelHeading={"Sign Using Keyboard"}
              selectedValue={selectedValueForSignKeyboard}
              onChange={(k, v) =>
                this.setState({ selectedValueForSignKeyboard: v })}
            />
          </div>
          <div className={"col-xs-12"}>
            <span className={"span-brr-label"}>
              {"Printed Name : "}<i>{this.props.requestedFor}</i>
            </span>
            <br />
            <br />
          </div>
          {selectedValueForSignKeyboard ? (
            <>
              <div className={"row"}>
                <div className={"col-xs-12 sign-label"}>
                  <canvas
                    id={"textCanvas"}
                    style={{display:"none",paddingTop:"5px" }}
                    height={"40"}
                  />

                  <TextFieldWithToolTip
                    id={"Signature"}
                    txtName={"Signature"}
                    disabled={false}
                    keyValue={"textSignature"}
                    isRequired={false}
                    labelHeading={"Enter Your Signature"}
                    toolTip={""}
                    value={this.state.textSignature}
                    onChange={this.changeState}
                  />
                  <br />
                </div>
              </div>
              <br />
              <br />
              <br />
              <span className={"span-brr-label"}>{"Preview :"}</span>
              {this.state.textSignature && (
                <>
                  {" "}
                  <div className={"col-xs-12 sign-label signature-canvas"}>
                    <TextFieldWithToolTip
                      id={"SignaturePreview"}
                      txtName={"SignaturePreview"}
                      disabled
                      keyValue={"textSignature"}
                      isRequired={false}
                      labelHeading={""}
                      toolTip={""}
                      value={this.state.textSignature}
                    />
                  </div>
                  <span style={{ marginLeft: "7px" }}>
                    {this.state.signingTimeFrame}
                  </span>
                </>
              )}
              <div className={"row"}>
                <div className={"col-xs-12 end-xs req-btn"}>
                  <Button
                    onClick={() => this.setToInitial()}
                    variant={"contained"}
                  >
                    {"Clear\r"}
                  </Button>
                  <Button
                    disabled={this.state.textSignature ? false : true}
                    onClick={() => {
                      this.props.isPOI
                        ? this.submitSignature()
                        : this.getKeyboardSignature();
                    }}
                    variant={"contained"}
                  >
                    {"Submit\r"}
                  </Button>
                </div>
              </div>
            </>
          ) : (
            <div className={""}>
              <div className={"sigContainer"}>
                <SignaturePad
                  canvasProps={{ width: 500, height: 200, className: "sigPad" }}
                  ref={(ref) => {
                    this.sigPad = ref;
                  }}
                  onEnd={() => {
                    this.setState({ isSigned: true });
                  }}
                />
              </div>
              <div className={"row"}>
                <div className={"col-xs-12 end-xs req-btn"}>
                  <span>{moment().format("MM/DD/YYYY hh:mm:ss")}</span>
                  <Button onClick={() => this.clear()} variant={"contained"}>
                    {"Clear\r"}
                  </Button>
                  <Button
                    disabled={isSigned ? false : true}
                    onClick={() => {
                      this.props.isPOI == true
                        ? this.submitSignatureCanvas()
                        : this.trim();
                    }}
                    variant={"contained"}
                  >
                    {"Submit\r"}
                  </Button>
                </div>
              </div>
            </div>
          )}
        </div>
      </>
    );
  }
}
